export const typeOfLazeImage = { avatar: "avatar", content: "content" };
